<template>
	<div v-if="parent_data" class="element el-progress-slider" :class="{ 'can-change': is_editable, 'has-labels': labels.length }">
		<div v-if="labels.length" class="slider-data">
			<span v-for="(label, index) in labels" :key="index">{{ label }}</span>
		</div>
		<div class="slider-bg" :class="gradient_bg" @click="change_value($event)" ref="slider_bg">
			<div class="slider-progress" :class="selector_bg" :style="{ width: value_percent + '%' }"><div class="tooltip">{{ value + '/' + max }}</div></div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";

export default {
	name: "el-progress-slider",
	mixins: [ ElementMixin ],
	data: function () {
		return {
			
		};
	},
	props: {
		labels: { default: function () { return []; } },
		max: { default: 100 },
		editable: { default: false },
		gradient_bg: { default: ""},
		selector_bg: {default: ""}
	},
	computed: {
		...mapGetters([ ]),
		value_percent: function () {
			return this.value * 100 / this.max;
		}
	},
	methods: {
		change_value: function ($event) {
			if (this.is_editable) {
				const x = $event.layerX;
				const percent = x * 100 / this.$refs.slider_bg.offsetWidth;
				const new_value = Number(Math.round((percent * this.max / 100)*2)/2);
				this.edit_study(new_value);
			}
		}
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

.el-progress-slider
	height 10px
	margin 4px 0 8px 0
	line-height @height
	&:hover
		.slider-bg .slider-progress .tooltip
			display block
	&.can-change
		&:before
			content ''
			position absolute
			left -7px
			top -7px
			right -7px
			bottom -7px
			box-shadow 0 0 0 1px purple
			background-color lighten(purple, 85%)
			border-radius 50px
		.slider-bg
			cursor pointer
			background-color #aaa
	.slider-data
		position absolute
		width 100%
		top 50%
		transform translateY(-50%)
		z-index 2
		font-weight bold
		display flex
		align-items center
		justify-content space-between
		font-size 9px
		color main_color
		line-height @height
		padding 0 6px
		pointer-events none
		span
			display inline-block
	.slider-bg
		height 100%
		width 100%
		background-color #ddd
		border-radius 8px
		// background repeating-linear-gradient(-55deg, #fff, #fff 2px, #ddd 2px, #ddd 4px )
		// background url(../../../../assets/img/stripe-light.png) top left
		&.yellow_green_bg
			background linear-gradient(to right, yellow, lightgreen)
		&.orange_green_bg
			background linear-gradient(to right, orange, lightgreen)

		.slider-progress
			position absolute
			left 0
			top 0
			bottom 0
			width 50%
			background blue
			// background-color main_color
			// background repeating-linear-gradient(-55deg, #fff, #fff 2px, darken(green, 25%) 2px, darken(green, 25%) 4px )
			// background url(../../../../assets/img/stripe-green.png) top left
			transition 0.1s easeOutQuart
			border-radius 8px
			&:after
				content ''
				position absolute
				right -8px
				top -2px
				bottom -2px
				width 14px
				background-color blue
				box-shadow 0 0 0 2px #fff
				border-radius 7px
			.tooltip
				display none
				position absolute
				right -2px
				top -36px
				height 24px
				padding 0 8px
				transform translateX(50%)
				background-color dark
				color #fff
				line-height 24px
				user-select none
				&:before
					content ''
					position absolute
					left calc(50% - 4px)
					bottom -4px
					width 0
					height 0
					border-style solid
					border-width 4px 4px 0 4px
					border-color dark transparent transparent transparent
			
			&.orange_selector
				background orange
				&:after
					background orange
	&.has-labels
		position relative
		height 17px
		z-index 0

		.slider-bg
			background linear-gradient(to right, #DADC50, #61B576)

		.slider-progress
			background transparent
			&:after
				width 8px //4px
				top -5px
				bottom -5px
				box-shadow none
				border-radius 4px
				background-color main_color
				border-color white
				border-style solid
				border-width 2px
			.tooltip
				right -7px
</style>
